<template>
  <div class="page-header"
       :style="bgImage"
  >
    <b-container fluid="xl" class="header-content">
      <NavBarPC v-if="!isMobile"/>
      <NavBarMobile v-else />

      <div class="header-style-2">
        <h1 v-html="title"></h1>
        <p v-html="content"></p>
      </div>
    </b-container>
  </div>
</template>

<script>
import NavBarPC from './NavBar-pc'
import NavBarMobile from './NavBar-mobile'
import runtime from '../utils/runtime'

// solution 中的子页面的头部
export default {
  name: 'HeaderStyles2',
  props: ['image', 'title', 'content'],
  components: {
    NavBarPC,
    NavBarMobile
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  },
  computed: {
    bgImage () {
      return {
        backgroundImage: `url(${this.image})`
      }
    }
  }
}
</script>

<style lang="scss">
  .lang-selector {
    .popover-body {
      padding: 10px 0 !important;
    }
  }
</style>
<style scoped lang="scss">
  .page-header {
    display: flex;
    flex-direction: column;
    height: 774px;
    background: linear-gradient(165deg, #6c63ff 60%, #c77cf1);
    border-radius: 0px 0px 50px 0px;
    padding-top: 60px;
    overflow-x: hidden;
    background-size: cover;
    background-position: center;

    .header-content {
      position: relative;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
  }

  .header-style-2 {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;

    h1 {
      font-size: 50px;
      font-weight: 700;
      color: #ffffff;
    }
    p {
      font-size: 16px;
      font-weight: 300;
      color: #ffffff;
      margin-top: 20px;
      max-width: 50%;
      padding-bottom: 100px;
    }
  }

</style>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .page-header {
      height: 400px;
      padding-top: 16px;
    }

    .header-style-2 {
      display: block;

      h1 {
        font-size: 30px;
        font-weight: 700;
        color: #ffffff;
        margin-top: 2em;
      }
      p {
        font-size: 10px;
        font-weight: 300;
        color: #ffffff;
        margin-top: 20px;
        max-width: 50%;
        padding-bottom: 100px;
      }
    }
  }
</style>
